<template>
    <div class="help-page">
        <PageTitleBanner :title="$t('m.helpTitle')" showBack/>

        <main class="help-page-body">
            <section class="help-menu-card">
                <button
                    v-for="item in menuItems"
                    :key="item.path"
                    v-active-touch
                    class="help-menu-row interactive-surface"
                    type="button"
                    @click="goTo(item.path)"
                >
                    <span class="help-menu-icon-wrap" :class="item.iconClass">
                        <component :is="item.iconComponent" class="help-menu-icon" aria-hidden="true" />
                    </span>
                    <span class="help-menu-label">{{ item.label }}</span>
                    <span class="help-menu-chevron" aria-hidden="true"></span>
                </button>
            </section>
        </main>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageTitleBanner from "@/components/PageTitleBanner.vue";
import HelpReportIcon from "@/components/icons/HelpReportIcon.vue";
import ReportChatIcon from "@/components/icons/ReportChatIcon.vue";
import { hasAboutUsContacts } from "@/utils/aboutUs";

export default {
    name: "Help",
    components: {
        PageTitleBanner,
        HelpReportIcon,
        ReportChatIcon,
    },
    computed: {
        ...mapGetters("appConfig", ["about_us"]),
        hasContactMethods() {
            return hasAboutUsContacts(this.about_us);
        },
        menuItems() {
            const items = [
                {
                    label: this.$t("m.helpReportProblem"),
                    path: "/report_problem",
                    iconComponent: "HelpReportIcon",
                    iconClass: "report",
                },
            ];

            if (this.hasContactMethods) {
                items.push({
                    label: this.$t("m.helpChatWithUs"),
                    path: "/chat_with_us",
                    iconComponent: "ReportChatIcon",
                    iconClass: "chat",
                });
            }

            return items;
        },
    },
    methods: {
        goTo(path) {
            this.$router.push({ path }).catch(() => {});
        },
    },
};
</script>

<style lang="scss">
.help-page {
    min-height: 100vh;
    background: #f7f7f7;
}

.help-page-body {
    padding: 20px 16px 32px;
}

.help-menu-card {
    overflow: hidden;
    background: #fff;
    border-radius: 5px;
}

.help-menu-row {
    width: 100%;
    height: 60px;
    border: 0;
    border-bottom: 1px solid #f2f2f2;
    background: #fff;
    display: flex;
    align-items: center;
    padding: 0 15px;
    font-family: SF Pro Text, Avenir, Helvetica, Arial, sans-serif;
    color: #333;
}

.help-menu-row:last-child {
    border-bottom: 0;
}

.help-menu-icon-wrap {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.help-menu-icon-wrap.report .help-menu-icon {
    width: 18px;
    height: 18px;
}

.help-menu-icon-wrap.chat .help-menu-icon {
    width: 17px;
    height: 17px;
}

.help-menu-icon {
    display: block;
}

.help-menu-label {
    flex: 1;
    min-width: 0;
    font-size: 16px;
    line-height: 20px;
    text-align: left;
}

.help-menu-chevron {
    width: 8px;
    height: 8px;
    border-top: 1.4px solid #c4c4c4;
    border-right: 1.4px solid #c4c4c4;
    transform: rotate(45deg);
    margin-right: 2px;
}
</style>
